module.exports = __webpack_public_path__ + "static/media/error500.891f99d5.svg";